import { Profile } from 'Core/common/Profile/types'
import { Http, HttpUser } from 'Core/utils/axios'

import { baseUsersUrl } from './constants'

export const retrieveProfile = (): Promise<Profile.Basic> => HttpUser.get(baseUsersUrl)

export const updateProfile = (params: Profile.Request.Edit): Promise<Profile.Basic> =>
	HttpUser.put(baseUsersUrl, params)

export const retrieveLocales = (): Promise<Profile.Locale[]> =>
	HttpUser.get(`${baseUsersUrl}/locales`)

export const retrieveEhsEnabled = (): Promise<Profile.Locale[]> =>
	Http.get('/companies/any-ehs-enabled')
